export default __webpack_public_path__ + "static/choose-63493f9e037cfc67b82ff1b346d8518b.svg";